import React from "react";
import "./Graph.scss";

/**
 * Graph graph
 * Based on https://codepen.io/sergiopedercini/pen/jmKdbj
 * @param {Object} props
 * @param {Number} props.value Percentage
 * @returns {React.ReactElement}
 */
function Graph({ value }) {
  return (
    <div className="Graph">
      <svg viewBox="0 0 42 42" className="Graph__svg">
        <path
          className="Graph__circle Graph__circle--bg"
          d="M18 2.0845
          a 15.9155 15.9155 0 0 1 0 31.831
          a 15.9155 15.9155 0 0 1 0 -31.831"
        />
        <path
          className="Graph__circle Graph__circle--value"
          style={{
            strokeDasharray: `${value}, 100`,
          }}
          d="M18 2.0845
          a 15.9155 15.9155 0 0 1 0 31.831
          a 15.9155 15.9155 0 0 1 0 -31.831"
        />
        <g className="Graph__text">
          <text x="18" y="20.35">
            {value}%
          </text>
        </g>
      </svg>
    </div>
  );
}

export default Graph;
